import { z } from "zod";

import { oauthFlowTypeSchema } from "./oauth-flow-type-schema";

export const oAuthConfigSchema = z.object({
	flowType: oauthFlowTypeSchema,
	tokenUrl: z.string(),
	clientId: z.string(),
	clientSecret: z.string(),
	username: z.string(),
	password: z.string(),
	scope: z.string().nullish(),
});
